module.exports = __webpack_public_path__ + "img/elperiodicodeaqui.fd3d2a3e.png";